// Contract addresses
export const CONTRACT_ADDRESS = "0x3059B722579949459a7A778771Ec5e2e990392A1";
export const ROLES_LIBRARY_ADDRESS = "0xF34D883EcdE77218D1A97510822BB8B54EB2C2CD";